import { render } from "./HiViewNoData.vue?vue&type=template&id=223570c6"
import script from "./HiViewNoData.vue?vue&type=script&lang=js"
export * from "./HiViewNoData.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__